export default __webpack_public_path__ + "static/media/carbon_document_attachment.ba624c75.svg";